
export class BroadridgeCode {
  code: string;
  dtcCodeId: number;
  globalCustodianId: number;
  localCustodianId: number;
  id: number;
  action: 'create' | 'update' | 'delete'
}
